module.exports = __webpack_public_path__ + "img/tg.88bf2b84.svg";